import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import React from 'react';
import { useIntl } from 'react-intl';
import { shallowEqual } from 'react-redux';

import routeConfiguration from '../../../../routeConfiguration';
import useAppSelector from '../../../../util/hooks/useAppSelector';
import { createResourceLocatorString } from '../../../../util/routes';
import Link from '../../../Links/Link/Link';
// Side-effect import: this module reads the StoryblokPage redux slice, which is injected
// lazily by the duck. Importing it keeps the reducer in whatever chunk this module lands in.
import '../../../../containers/StoryblokPage/StoryblokPage.duck';

/**
 * Pagination for blog posts
 * @param {object} props - props
 * @param {string} props.currentCategory - current category
 * @param {string | number} props.currentPage - current page
 */
const StoryblokArchiveBlogPagination = ({ currentCategory = '', currentPage = 0 }) => {
  const intl = useIntl();
  const { blogPostStoriesPagination, blogPostStoriesInProgress } = useAppSelector(
    (state) => ({
      blogPostStoriesPagination: state.StoryblokPage.blogPostStoriesPagination,
      blogPostStoriesInProgress: state.StoryblokPage.blogPostStoriesInProgress,
    }),
    shallowEqual
  );
  const { perPage, total } = blogPostStoriesPagination;
  const totalPages = Math.ceil(total / perPage);
  const pageNumber = parseInt(currentPage);

  return (
    !blogPostStoriesInProgress && (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Pagination
          count={totalPages}
          hideNextButton={pageNumber === totalPages}
          hidePrevButton={pageNumber === 1}
          page={pageNumber}
          renderItem={(item) => (
            <PaginationItem
              component={Link}
              to={createResourceLocatorString(
                'StoryblokPage',
                routeConfiguration(),
                { slug: 'blog' },
                {
                  page: item.page !== 1 ? item.page : undefined,
                  ...(currentCategory ? { category: currentCategory } : {}),
                },
                intl.locale
              )}
              {...item}
            />
          )}
          size="large"
        />
      </Box>
    )
  );
};

export default StoryblokArchiveBlogPagination;
